// React
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// UI
import { Users } from 'lucide-react';
import { toast } from 'sonner';
import { Input } from '../components/ui/input';
import { Toaster } from '../components/ui/sonner';

// FutureLab
import { useCreatePrivateChatMutation } from '../store/api/chatApi';
import { useLazyGetDirectoryUsersQuery } from '../store/api/userApi';
import { chatItemInFocus } from '../actions/chatItemInFocusActions';

// Reducer
import { store } from '../ReduxRoot';

export interface UserProfileDetails {
	id: number;
	email: string;
	profile_photo: string;
	firstname: string;
	lastname: string;
	userRoles: UserRolesInterface[];
	userInfos: UserInfosInterface;
}

export interface UserRolesInterface {
	active: boolean;
	createdAt: Date;
	deactivatedAt: Date;
	description: string;
	id: number;
	name: string;
	programId: number;
	updatedAt: Date;
}

export interface UserInfosInterface {
	userId: number;
	id: number;
	jobTitle: string;
	company: string;
	gender: number;
	birthday: Date;
}

export function AddChatPage() {
	const [userList, setUserList] = useState<UserProfileDetails[]>([]);
	const [filterQuery, setFilterQuery] = useState('');
	const [createPrivateChat] = useCreatePrivateChatMutation();
	const [loadDirectoryUsers] = useLazyGetDirectoryUsersQuery();
	const navigate = useNavigate();
	const filterObject = {
		filter: {
			firstName: '',
			lastName: '',
			email: '',
		},
	};

	const photoUrl = `${process.env.REACT_APP_PROFILE_PHOTOS_BASE_URL}${process.env.REACT_APP_PROFILE_PHOTOS_S3_BASE_URL}${process.env.REACT_APP_PROFILE_PHOTOS_S3_DIRECTORY_URL}`;

	const getGeryResults = () => {
		return userList.filter((user) => user.email.includes(filterQuery));
	};

	const createPrivateGroupChatAndRoute = (userId: number): void => {
		createPrivateChat({ recipientUserId: userId })
			.unwrap()
			.then((chat) => {
				store.dispatch(chatItemInFocus(chat));
			})
			.then(() => {
				navigate('../chat/chat-room');
			})
			.catch(() => toast.error('Chat Already Exists'));
	};

	useEffect(() => {
		loadDirectoryUsers(filterObject)
			.unwrap()
			.then((users) => {
				setUserList(users);
			})
			.catch((err) => {
				console.warn('Error:', err);
			});
	}, [loadDirectoryUsers]);

	return (
		<div className="add-group-chat h-full min-w-0 overflow-x-hidden">
			<Toaster position="bottom-center" />
			<button
				type="button"
				className="new-group-user-button flex w-full min-w-0 items-center text-left"
				onClick={() => navigate('../chat/add-group-chat')}
			>
				<div className="w-16 shrink-0">
					<div className="chat-list-photo-holder">
						<Users className="chat-list-image-holder group-chat-list-image-holder p-3 text-muted-foreground" />
					</div>
				</div>
				<div className="add-chatlist-one-to-one-title min-w-0 flex-1 truncate pr-3">
					New Group
				</div>
			</button>
			<div className="search-chat-bar min-w-0">
				<Input
					aria-label="Search users"
					placeholder="Search"
					value={filterQuery}
					onChange={(event) => setFilterQuery(event.target.value)}
				/>
			</div>
			<div className="vertical-scroll-enabled-chat-page min-w-0 overflow-x-hidden">
				{getGeryResults().map((user) => {
					return (
						<button
							type="button"
							key={user.id}
							className="user-list-row flex w-full min-w-0 items-center text-left"
							onClick={() => createPrivateGroupChatAndRoute(user.id)}
						>
								<div className="w-16 shrink-0">
									<div className="chat-list-photo-holder">
										<img
											src={`${photoUrl}/${user.id}/${user.profile_photo}`}
											className="chat-list-image-holder"
											alt=""
										/>
									</div>
								</div>
								<div className="add-chatlist-one-to-one-title min-w-0 flex-1 pr-3">
									<div className="truncate">{user.email}</div>
								</div>
						</button>
					);
				})}
			</div>
		</div>
	);
}
